import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import Layout from "components/Screens/CustomerOnboarding/Layout";
import Button from "components/common/Button";

import {
  CheckCircle as CheckCircleIcon,
  AttachMoney as AttachMoneyIcon,
  AccountBalanceOutlined as AccountBalanceOutlinedIcon,
  CreditCardOutlined as CreditCardOutlinedIcon,
} from "@mui/icons-material";

import { CUSTOMER_ONBOARDING_CALENDLY_MEETING_ROUTE } from "constants/routes";

import "./PaymentSuccess.scss";
import { useSelector } from "react-redux";
import { getUserAdditionalInfo } from "selectors/user";
import { formatDate } from "components/Screens/Setting/utils";

function PaymentSuccess() {
  const navigate = useNavigate();
  const { skipKickoffCall: skipKickoffCallFlag } = useFlags();
  const userInfo = useSelector(getUserAdditionalInfo);
  const { state: locationState } = useLocation();
  const { chargeInitiated = true, scheduledAt = null } = locationState ?? {};

  const { paymentMethod = "ACH" } = userInfo;

  const isKickoffSkipped = skipKickoffCallFlag && userInfo?.skipKickoffCall === true;

  const handleNextClick = () => {
    if (isKickoffSkipped) {
      navigate("/main/dashboard");
    } else {
      navigate(CUSTOMER_ONBOARDING_CALENDLY_MEETING_ROUTE);
    }
  };
  return (
    <Layout title="Confirm your payment">
      <div className="onboarding-payment-success-container">
        <div>
          <CheckCircleIcon className="payment-check-circle" />
          <p className="heading-h1-semibold pb-05 pt-1">Payment details received</p>
          <p className="para-body-m-regular color-text-body-primary">
            {chargeInitiated ? (
              " We've received your payment details, and your payment is on its way to being processed. It may take 3-5 business days to complete."
            ) : (
              <>
                We expect to process your payment on{" "}
                <span className="para-body-m-semibold">{formatDate(scheduledAt)}</span>. Processing times may shift by
                up to 2 business days.
              </>
            )}
          </p>
        </div>
        <div className="onboarding-payment-container">
          <p className="para-body-l-semibold">Here's how you stay in the loop:</p>
          <div className="onboarding-payment-list">
            <AttachMoneyIcon className="payment-dollar-circle" />
            <div>
              <p className="para-body-m-medium">Want to know the payment status?</p>
              <p className="para-body-s-regular color-text-body-primary">
                Check the payment status anytime on our platform.
              </p>
            </div>
          </div>
          <div className="onboarding-payment-list">
            {paymentMethod === "CREDIT_CARD" ? (
              <CreditCardOutlinedIcon className="payment-dollar-circle" />
            ) : (
              <AccountBalanceOutlinedIcon className="payment-dollar-circle" />
            )}
            <div>
              <p className="para-body-m-medium">Need to make updates later?</p>
              <p className="para-body-s-regular color-text-body-primary">
                No problem—you can update your payment method on our platform.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="onboarding-payment-success-button">
        <div className="onboarding-payment-success-button-container">
          <Button
            onClick={handleNextClick}
            label={isKickoffSkipped ? "Continue" : "Schedule Kick-off Call"}
            size="large"
          />
        </div>
      </div>
    </Layout>
  );
}

export default PaymentSuccess;
